import { supabase } from "./supabase";

export interface Provider {
  id: number;
  user_id: string;
  company_name: string;
  description: string;
  logo_url: string;
  city: string;
  phone: string;
  commercial_reg: string;
  service_types: string[];
  status: string;
  coverage_radius: number;
  coverage_lat: number;
  coverage_lng: number;
  coverage_address: string;
  bank_name: string;
  bank_iban: string;
  bank_account_name: string;
  accept_duration: string;
  max_concurrent_orders: number;
  auto_accept: boolean;
  working_hours: WorkDay[] | null;
  service_durations: Record<string, string> | null;
  created_at: string;
  updated_at: string;
}

export interface WorkDay {
  key: string;
  label: string;
  open: string;
  close: string;
  closed: boolean;
}

export async function getCurrentProvider(): Promise<Provider | null> {
  const {
    data: { user },
  } = await supabase.auth.getUser();
  if (!user) return null;

  const { data } = await supabase
    .from("providers")
    .select("*")
    .eq("user_id", user.id)
    .maybeSingle();

  return (data as Provider) ?? null;
}